import React from 'react';

const HpRespPersonalizedCategories = React.lazy(() =>
    import(/* webpackChunkName: "HpRespPersonalizedCategories" */ './HpRespPersonalizedCategories')
);

export function HpRespPersonalizedCategoriesLoader(props) {
    return (
        <React.Suspense fallback={null}>
            <HpRespPersonalizedCategories {...props} />
        </React.Suspense>
    );
}
